import React, { createContext, useContext } from 'react';
import type { SpellCastingPreviews, SpellCastingPreview } from '../api';

const emptyPreviews: SpellCastingPreviews = {};
const PreviewsContext = createContext<SpellCastingPreviews>(emptyPreviews);
export const SpellInvestigatorContext = createContext<string | undefined>(undefined);
export const SpellActionPreviewContext = createContext<{ spellId?: string; preview?: SpellCastingPreview } | undefined>(undefined);

export const SpellCastingPreviewsProvider: React.FC<{ previews?: SpellCastingPreviews; children: React.ReactNode }> = ({ previews, children }) => {
  const inherited = useContext(PreviewsContext);
  return <PreviewsContext.Provider value={previews ?? inherited}>{children}</PreviewsContext.Provider>;
};

export const useSpellCastingPreview = (id?: string) => {
  const previews = useContext(PreviewsContext);
  const investigator = useContext(SpellInvestigatorContext);
  const action = useContext(SpellActionPreviewContext);
  if (id && action?.spellId === id && action.preview) return action.preview;
  if (!id || !investigator) return undefined;
  const name = Object.keys(previews).find(name => name.toLowerCase() === investigator.toLowerCase());
  const preview = name ? previews[name]?.[id] : undefined;
  // An unresolved action must not borrow another action's target through inventory context.
  return preview && action?.spellId === id
    ? { ...preview, currentCastingModifier: null, castingModifierExplanation: null } : preview;
};
